import React, { useEffect } from "react";
import { HeroSection } from "./HeroSection";
import { WaitlistSection } from "./WaitlistSection";
import { MissionSection } from "./MissionSection";
import { SiteFooter } from "./SiteFooter";
import { LANDING } from "@/constants/testIds/waitlist";

export const LandingPage = () => {
  useEffect(() => {
    document.title = "CoreX Athlete Development";
  }, []);

  return (
    <div data-testid={LANDING.page} className="min-h-screen bg-black text-white">
      <main>
        <HeroSection />
        <WaitlistSection />
        <MissionSection />
      </main>
      <SiteFooter />
    </div>
  );
};

export default LandingPage;
